import { CLASSES } from '../_consts';

const { isActive } = CLASSES;

export default function tabsInit() {

  const linkSelector = '.js-tab-link';
  const $links = $(linkSelector);
  const linkedContentEl = '.js-tab-content';
  const $accessoriesSlider = $('.js-accessories-slider');

  $links.on('click', (e) => {
    e.preventDefault();
    const $current = $(e.currentTarget);
    const target = $current.data('tab-target');

    $(`${linkedContentEl}[data-tab-content="${target}"]`).addClass(isActive).siblings(linkedContentEl).removeClass(isActive);

    if (target === 'accessories') {
      $accessoriesSlider.hide();
    } else {
      $accessoriesSlider.show();
    }

    $current.addClass(isActive).siblings(linkSelector).removeClass(isActive);
  })
}